// define(["ulysses/base", "jquery", "knockout", "../api", 
//         "ulysses/widgets/calendar.html", "moment", 
//         "@fullcalendar/core", 
//         "@fullcalendar/daygrid", 
//         "@fullcalendar/timegrid", "@fullcalendar/list",
//         "../widgets"], 
//     function(uly, $, ko, HalResource, markup, moment, fc, 
//              daygridPlugin, timegridPlugin, listPlugin) {

    import "@fullcalendar/common/main.css";
    import uly from "ulysses/base";
    import $ from "jquery";
    import ko from "knockout";
    import HalResource from "../api";
    import markup from "ulysses/widgets/calendar.html";
    import moment from "moment";
    import { Calendar } from "@fullcalendar/core";
    import daygridPlugin from "@fullcalendar/daygrid";
    import timegridPlugin from "@fullcalendar/timegrid";
    import listPlugin from "@fullcalendar/list";
    import bootstrapPlugin from '@fullcalendar/bootstrap';
    import interactionPlugin, {ThirdPartyDraggable} from '@fullcalendar/interaction';
    import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
    import { fetch_item_actions } from "ulysses/widgets/search/search_item";
    import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
    import dragula from "dragula";

    $(document).ready(function() { $(markup).appendTo($("body")); });
    window.moment = moment;
    var edit_calendar_settings = function edit_calendar_settings(current_data) {
        var res = Promise.Deferred();
        var cdata = Object.assign({"editable": false},ko.toJS(current_data));
        var dialog = uly.dialogs.execute($("#calendar-settings-editor-tmpl").html(), {
            "title":_("calendar_title_edit_calendar_configuration", "Edit Calendar Configuration")
        }, cdata).done(function([result]) {
            res.resolve({
                "view_type":ko.unwrap(result.view_type) || "month",
                "contextual":ko.unwrap(result.contextual) || "no",
                "editable":ko.unwrap(result.editable) || false,
                "start":ko.unwrap(result.start) || "scheduled_start_date",
                "end":ko.unwrap(result.end) || "scheduled_completion_date",
                "filter":ko.unwrap(result.filter) || null
            });
        }).fail(res.reject);
        return res.promise();
    };
    ko.bindingHandlers.calendar = {
        "init":function(elt, va, bindings, model, context) {
            var widget_model = ko.unwrap(bindings().widget);
            var settings = ko.toJS(va());
            var calendar_details = $(elt).next(".calendar-details")[0];
            var default_filter = settings.start+"_tdt:[* TO {end}] AND "+settings.end+"_tdt:[{start} TO *]";
            default_filter = "in_calendar_b:true AND _type:calevent AND (" + default_filter + ")"

            if (settings.filter) {
                settings.filter = "(" + settings.filter + ") AND (" + default_filter + ")";
            } else {
                settings.filter = default_filter;
            }
            var query = uly.utils.filter_search_by_page({}, settings, {}, context);
            query["page_size"] = 1000;
            var previous_data = null;
            function map_view_type(vt) {
                if (vt == "month") {
                    return "dayGridMonth";
                } else if (vt == "resourceTimegridDay") {
                    return "resourceTimeGridDay";
                }
                return vt;
            }
            function schedule_event(ev) {
                let scheduleAction = ev.extendedProps.edit_action;
                let res = ev.getResources()[0];
                let assignee_id = null;
                if (res) {
                    assignee_id = res.id;
                }
                assignee_id = assignee_id;
                return HalResource(scheduleAction).post(null, {
                    "scheduled_start_date": ev.start,
                    "scheduled_completion_date": ev.end,
                    "assignee_id": assignee_id,
                    "id": ev.id
                }).then((result)=>{
                    uly.utils.show_results(result);
                    dropInfo.revert();
                    return result;
                }, (error)=>{
                    uly.utils.show_results(error);
                    dropInfo.revert();
                    return error;
                })

            }
            var cal = new Calendar(elt, {
                plugins: [daygridPlugin, timegridPlugin, listPlugin,
                     interactionPlugin, resourceTimelinePlugin,
                     resourceTimeGridPlugin
                ],
                //initialView: "dayGridMonth",
			    initialView: map_view_type(settings.view_type),
                themeSystem: "standard",
                headerToolbar: {
                    start: "prev,next today",
                    center: "title",
                    end: "dayGridMonth,timeGridWeek,listWeek,resourceTimelineWeek"
                },
//            })
//            const s = ({
                businessHours: true,
                slotMinTime: "08:00:00",
                slotMaxTime: "21:00:00",
                timeZone: "local",
                editable: true,
			    buttonText: {
                    today: _("frontend_calendar_today", "Today"),
                    month: _("frontend_calendar_month_view", "M"),
                    week: _("frontend_calendar_week_view", "W"),
                    day: _("frontend_calendar_day_view", "D"),
                    list: _("frontend_calendar_list_view", "L"),
                    resourceTimelineWeek: "R"
                },
			    buttonIcons:{
                    prev: ' fa fa-caret-left',
                    next: ' fa fa-caret-right'
                },
			    eventClick: function(info) {
                    const e = info.jsEvent;
                    const event = info.event;
			        e.preventDefault();
                    console.log("event click:", event);
                    $(elt).find(".event-active").removeClass("event-active");
                    $(e.currentTarget).addClass("event-active");
                    $.data(elt, "active", event.id);
                    if (event.url) {
                        uly.actions.navigateto(event.url);
                        return;
                    }
                    var result = event;
                    result.actions = ko.observableArray([]);
                    result.timers = ko.observableArray([]);

                    HalResource(event).follow_with_cache("uly:actions",uly.api.action_cache).done(function(actions) {
                        result["actions"](uly.actions.classifyActions(actions, event, true));
                    });
                    HalResource(event).follow("timers").done(function(timers) {
                        result.timers(timers);
                    }).always(function(){
                        ko.renderTemplate("search-result-tmp",
                                          $.extend(result, { "collapsed": ko.observable(false), toggle_row: function() {}}),
                                          {}, calendar_details, 'replaceChildren');
                        $(elt).fullCalendar('rerenderEvents');
                    });
                },
                dateClick: function(info) {
                    var context = ko.contextFor(elt);

                    context.params = { "start": info.date.toISOString()};
                    $(elt).trigger("action:createappointment", { context: context });

                },
                viewRender:function(view){
                    if (view.name != settings.view_type){
                        widget_model.settings.view_type = view.name;
                        uly.publish("page.savesettings");
                    }
                },
			    eventContent: function(eventInfo) {
                    const event = eventInfo.event;
                    return { "html": `
                    <div title="{0}" style="text-overflow:ellipsis;max-width:100%;overflow:hidden;white-space:nowrap;">
                        <i class="fa {1}"></i>
                        <strong>{2}</strong>
                        <span>{0}</span>
                    </div>
                                `.format(event.title, event.extendedProps.model_icon, moment(event.start).format("H:mm"))
                    };
                },
                eventReceive: (eventInfo) => {
                    console.log("Event received:", eventInfo);
                    schedule_event(eventInfo.event).then( (result)=> {
                        if (!result.success) {
                            eventInfo.revert();
                        }
                        cal.refetchEvents();
                    }, (error) => {
                        eventInfo.revert();
                    });

                },
                resources: function(info, success, failure) {
                    uly.api.start().follow("uly:search").follow("uly:results", {
                        "q": {
                           fq: "is:user AND type:contact"
                        },
                        "fields": [
                            "type__t",
                            "title_t",
                            "id",
                            "id_s"
                        ],
                        "display_mode":"grid"

                    }).follow("item").then(
                        (items)=>{
                            for(var i=0;i<items.length;++i) {
                                items["title"] = items["title_t"]
                            }
                            success(items);
                        },
                        (error)=>{
                            failure(error);
                        }
                    )
                },
                eventDropp: (dropInfo) => {
                    console.log("Drop Event:", dropInfo);
                    let ev = dropInfo.event;
                    if (!ev.extendedProps.edit_action) {
                        dropInfo.revert();
                        return false;
                    }
                    schedule_event(ev).then( (result)=> {
                        if (!result.success) {
                            dropInfo.revert();
                        }
                        cal.refetchEvents();
                    }, (error) => {
                        dropInfo.revert();
                    });

                },
                eventChange: (changeInfo) => {
                    const ev = changeInfo.event;
                    if (!ev.extendedProps.edit_action) {
                        changeInfo.revert();
                        return;
                    }
                    schedule_event(ev).then( (result) => {
                        if (!result.success) {
                            changeInfo.revert();
                        }
                        //cal.refetchEvents();
                    }, (error) => {
                        changeInfo.revert();
                    });
                },
                events: function({start, end, timeZone}, callback) {
                    if (cal) { 
                        var old_events = cal.getEvents();
                        console.log("old events:", old_events.map((ev)=>ev.id));
                    }

                    var $query = $.extend(true, {}, query);
                    var fstart = null, fend = null;
                    if (start.hasTime && start.hasTime() && start.hasZone && !start.hasZone()) {
                        fstart = start.toISOString() + "Z";
                    } else {
                        fstart = start.toISOString();
                    }
                    if (end.hasTime && end.hasTime() && end.hasZone && !end.hasZone()) {
                        fend = end.toISOString() + "Z";
                    } else {
                        fend = end.toISOString();
                    }
                    $query.fq = $query.fq.map(function(val) {
                            return (val || "")
                                .replace(/\{start\}/g,fstart)
                                .replace(/\{end\}/g,fend);
                    });
                    
                    uly.api.start().follow("uly:search").follow("uly:results", { 
                        "q": $query || {}, 
                        "fields":["type__t", "in_calendar_s", "is_all_day_b", settings.start+"_tdt", settings.end+"_tdt", "title_t", "assignee_id"], 
                        "display_mode":"grid",
                        "skip_facets": true
                    }).follow("item").then(function(data) {
                        var events=[];
                        var ids = [];
                        var promises = [];
                        for (var i=0;i<data.length;i++){
                            data[i]["start"] = data[i][settings.start+"_tdt"];
                            data[i]["end"] = data[i][settings.end+"_tdt"];
                            if (settings.start == settings.end) {
                                data[i]["allDay"] = false;
                            } else {
                                data[i]["allDay"] = data[i]["is_all_day_b"] || false;
                            }
                            data[i]["url"] = data[i]["unique_id"].replace("#", "/");
                            data[i]["color"] = "var(--{0})".format(data[i].model_colour);
                            data[i]["resourceId"] = data[i].assignee_id;
                            (function(item) {
                                promises.push(
                                    fetch_item_actions(HalResource(item)).then((result) => {
                                        item.actions = result.actions;
                                        item.actions_by_set = result.by_set;
                                        item.edit_action = result.by_set.scheduler[0];
                                        if (result.by_set.scheduler && result.by_set.scheduler[0].name == "scheduleaction") {
                                            item.editable = true;
                                        } else {
                                            item.editable = false;
                                        }
                                    })
                                )
                            })(data[i]);
                            ids.push(data[i].unique_id);
                        }
                        data = data.filter(function(v) { return v.start; });
                        if (data && data.length) {
                            Promise.all(promises).then(()=>{
                                console.log("new events:", data.map((ev)=>ev.id));
                                callback(data);
                            });
                        } else {
                            callback(data);
                        }
                        previous_data = uly.bulkSubscribeToChange(ids, previous_data, calendar_result_changed, elt);
                    }).fail(function(result) {
                        console.error("Failed fetching calendar events", result);
                    });
                }
            });
            var calendar_result_changed = function calendar_result_changed() {
                uly.utils.throttle(elt, function() {
                    cal.refetchEvents();
                }, 500);
            };

            $(elt).data("ulycal", cal);
            cal.render();
            uly.publish("widget.active", elt);
        }
    };
    ko.bindingHandlers.calendarwidget = {
        "inititial_value":function(){
            var data = {
                "view_type": "month",
                "filter": null,
                "contextual": "no",
                "editable": false,
                "start": "scheduled_start_date",
                "end": "scheduled_completion_date"
            };
            var init_def = Promise.Deferred();
            edit_calendar_settings(data).done(function(result) {
                data.view_type = result.view_type;
                data.filter = result.filter;
                data.contextual = result.contextual;
                data.start  = result.start ? result.start : "scheduled_start_date";
                data.end = result.end ? result.end : "scheduled_completion_date";
                data.editable = result.editable ? true : false;
                init_def.resolve(data);
            }).fail(init_def.reject);
            return init_def;
        },
        "init":function(elt, va, bindings, model, context) {

            var widget_model = ko.unwrap(va());
            widget_model.show_header(true);
            widget_model.icon("fa fa-calendar");
            widget_model.error = ko.observable(null);
            var settings = ko.unwrap(widget_model.settings);
            $.each({
                "view_type": "month",
                "filter":null
            }, function(key,value) {
                if (typeof settings[key] == "undefined")
                    settings[key] = value;
            });


            var settings_menu = widget_model.settings_menu;
            // Ensure settings are complete
            settings_menu.push({
                "caption":_("calendar_caption_modify", "Modify"),
                "icon":"fa-edit",
                "action":function(e){
                    var settings = ko.unwrap(widget_model.settings);
                    var component_type = settings.compact ? "sidebar" : "page";
                    edit_calendar_settings(settings).done(function(result) {
                        settings = $.extend({}, settings, {
                            filter: result.filter,
                            contextual: result.contextual,
                            editable: result.editable,
                            view_type:  result.view_type,
                            start: result.start,
                            end: result.end
                        });
                        widget_model.settings(settings);
                        uly.publish(component_type + ".savesettings");
                    });
                },
                "colour":"primary",
                "permission": "editpage"
            });


            var $calendar_elt = $(elt).children(".calendar");
            var childContext = context.extend({"widget_model":widget_model});
            ko.applyBindingsToDescendants(childContext, elt);

            uly.subscribe("widget.remove", function(topic, widget) {
                if (widget != elt)
                    return false;
                ko.removeNode(elt);
            }, elt);

            return { controlsDescendantBindings: true };
        },
        "update":function(elt, va, allbindings, model, context) {

            var calendar_settings = ko.toJS(va().settings);
            var widget_model = ko.unwrap(va());
            var updating = $(elt).children(".calendar").data("calendar-updating");
            if (updating)
                return;
            uly.publish("widget.loading", elt);
        }
    };

    uly.widgets.register({
        "type":"calendar",
        "caption":_("calendar_caption_calendar", "Calendar"),
        "description":_("calendar_description_a_calendar_widget", "A calendar widget"),
        "icon":"fa-calendar",
        "init":ko.bindingHandlers.calendarwidget.inititial_value,
        "colour":"warning",
        "actions":[{
            "caption":_("calendar_caption_settings", "Settings"),
            "icon":"fa-cog",
            "action":function(e){
                return false;
            },
            "colour":"warning",
            "permission": "editpage"
        }]
    });

    //Register all search resutls to be draggable
    new ThirdPartyDraggable({
        "itemSelector": ".search-results .search-result",
        "mirrorSelector": ".gu-mirror",
        eventData: (eventEl) => {
            let data = ko.toJS(ko.dataFor(eventEl));
            data.start = data.scheduled_start_date;
            data.end = data.scheduled_end_date;
            data.url = data.unique_id && data.unique_id.replace("#", "/");
            data.color = "var(--{0})".format(data.model_colour);
            data.resourceId = data.assignee_id;
            let edit_action = data.actions_by_set && data.actions_by_set.scheduler && data.actions_by_set.scheduler[0];
            if (edit_action) {
                data.editable = true;
                data.edit_action = edit_action;
            }
            return data;
        }
    });

    
    let drake = dragula({
        isContainer: function(el) {
            if (el.parentElement && el.parentElement.classList.contains("search-results")) {
                console.log("Do I have a container:", el, el.classList);
            }
            return el.parentElement && el.parentElement.classList.contains("search-results");
        },
        copy: true,
        accepts: () => { return false; },
        moves: (el) => { return $(el).closest(".search-results")[0]; },
    })
// });
